<div class="field-button" [ngClass]="{'clicked': clicked, 'disabled': disabled, 'updateButtonStyle': updateButtonStyle}"
  [ngStyle]="{'background-color': backgroundColor || null, 'color': Color || null, 'flex-direction': flexDirection || null}" (click)="handleButtonClick($event)">
  <div *ngIf="iconUrl?.length" class="button-icon">
    <img [src]="iconUrl">
  </div>
  <div *ngIf="buttonText.length" [ngStyle]="{'color': Color || null}" class="button-text">{{buttonText}}</div>
</div>